import { z } from 'zod';
import { Validation } from '@mews/framework';
import {
    PortfolioCentralRateGroupAddParameters,
    PortfolioRateGroupOptions,
    PortfolioSettlementExtent,
} from '@mews-commander/data-access';
import { paymentPolicySchema } from '../../../../../../rateGroups';
import { DetailsFieldName } from '../../../../../types';
import { createSettlementConfigurationSchema } from '../../../../../../rateGroups/schemas';
import { SettlementConfigurationsFieldName } from '../../../../../../rateGroups/components/forms/types';

export const rateGroupDetailsSchema = z.object({
    [DetailsFieldName.RateGroupType]: z.union([z.literal('central'), z.literal('local')]),
    [DetailsFieldName.ServiceKey]: Validation.String.Required.max(70),
    [DetailsFieldName.Name]: Validation.String.Required.max(200),
    [DetailsFieldName.ShortName]: z.string().max(70).nullish(),
    [DetailsFieldName.Description]: z.string().max(70).nullish(),
    [DetailsFieldName.RateGroupKey]: Validation.String.Required.max(70),
});

export const rateGroupSchema = rateGroupDetailsSchema
    .merge(
        createSettlementConfigurationSchema({
            settlementExtent: PortfolioSettlementExtent,
            rateGroupOptions: PortfolioRateGroupOptions,
        }).omit({ [SettlementConfigurationsFieldName.CurrencyCode]: true })
    )
    .merge(paymentPolicySchema);

export type RateGroupFormValues = z.input<typeof rateGroupSchema>;

export const toPortfolioCentralRateGroupAddParameters = (
    formValues: RateGroupFormValues
): PortfolioCentralRateGroupAddParameters => ({
    isCentral: formValues.rateGroupType === 'central',
    ordering: 0,
    serviceKey: formValues.serviceKey,
    name: formValues.name,
    shortName: formValues.shortName ?? null,
    description: formValues.description ?? null,
    rateGroupKey: formValues.rateGroupKey,
    settlementMaximumTimeUnits: formValues.maximumTime || null,
    settlementExtent: formValues.extent,
    options: formValues.options ?? [],
    settlementRulesIds: formValues.settlementRules ?? [],
    cancellationPoliciesIds: formValues.cancellationFees ?? [],
});
